import { ArrowRight, BatteryCharging, Cable, DeviceMobile, Laptop, Technician } from '../ui/icons';
import { Link } from 'react-router-dom';
import { useI18n } from '../../hooks/useI18n';
import Button from '../ui/Button';

const SERVICES = [
  { key: 'service_issue_phone_screen', labelKey: 'service_issue_phone_screen', Icon: DeviceMobile, color: 'text-brand', bg: 'border-brand/40 bg-brand/15' },
  { key: 'service_issue_battery', labelKey: undefined, Icon: BatteryCharging, color: 'text-success', bg: 'border-success/40 bg-success/15' },
  { key: 'service_issue_charging', labelKey: undefined, Icon: Cable, color: 'text-warning', bg: 'border-warning/40 bg-warning/15' },
  { key: 'service_issue_software', labelKey: undefined, Icon: Laptop, color: 'text-brand', bg: 'border-brand/40 bg-brand/15' },
] as const;

export default function ServicesPreview() {
  const { t } = useI18n();

  return (
    <section data-testid="storefront-services" className="home-snap-section pt-14 pb-20 sm:pb-12 lg:pb-14 md:min-h-0">
      <div className="container mx-auto px-4">
        <div className="service-preview-panel glass rounded-3xl border-line/70 p-6 sm:p-8">
          <div className="grid items-center gap-8 lg:grid-cols-12">
            <div className="flex h-full flex-col justify-center lg:col-span-5 lg:pr-6">
              <h2 className="font-display max-w-md text-4xl font-bold leading-[0.95] sm:text-5xl lg:text-6xl">
                <span className="bg-gradient-to-r from-brand via-accent to-brand bg-clip-text text-transparent">{t('btn_tech_service')}</span>
              </h2>
              <p className="mt-5 max-w-md text-lg leading-relaxed text-ink/80 sm:text-xl">{t('services_sub')}</p>
              <Link to="/services" className="mt-8 inline-flex w-fit"><Button variant="glass-secondary" className="flex items-center gap-2 shadow-md shadow-brand/10 animate-[logo-glow-pulse-box_8s_ease-in-out_infinite]"><Technician className="h-5 w-5 shrink-0" />{t('btn_services')}<ArrowRight className="h-5 w-5 shrink-0" /></Button></Link>
            </div>
            <div className="lg:col-span-7">
              <div className="glass rounded-3xl border-line/80 bg-gradient-to-br from-raised/80 via-surface/85 to-accent/15 p-6 sm:p-8">
                <h2 className="font-display mb-4 text-lg font-semibold text-ink">{t('service_issue_type')}</h2>
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
                  {SERVICES.map(({ key, labelKey, Icon, color, bg }) => (
                    <Link
                      key={key}
                      to="/services"
                      state={{ service: key }}
                      className={`flex min-w-0 items-center gap-3 overflow-hidden rounded-xl border px-4 py-3 text-left transition-colors hover:brightness-110 ${bg}`}
                    >
                      <Icon className={`h-8 w-8 shrink-0 ${color}`} />
                      <span className="min-w-0 break-words font-medium leading-snug text-ink">{t(labelKey ?? key)}</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
